import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AccountInfo } from '../../modules/buildings-shared/model/account-info';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { UserInfo } from '../../modules/buildings-shared/model/user-info';
import { SharedUtils } from '../../modules/buildings-shared/utilities/shared-utils';
import { EncodeErrorInfo, EnumEncodeError } from '../../modules/buildings-shared/model/encode-error-info';
import { EnumUserLegalEntityStatus } from '../../modules/buildings-shared/model/user-legal-entity-info';

@Component({
  selector: 'app-login',
  imports: [FormsModule, RouterLink, RouterLinkActive],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

    usernameOrEmail: string = '';
    userPassword: string = '';
    passwordHidden: boolean = true;
    error: boolean = false;

    usernameMinLength: number = 6;
    passwordMinLength: number = 8;

    constructor(private readonly permissionService: PermissionService, private readonly router: Router) {}

    onSubmit(form: NgForm): void {
        this.permissionService.setWaitingSpinner(true);
        // console.log("LoginComponent.onSubmit(). usernameOrEmail: " + this.usernameOrEmail);
        this.usernameOrEmail = form.value.email;
        this.userPassword = form.value.password;
        const accountInfo: AccountInfo = new AccountInfo();
        if (this.usernameOrEmail.indexOf("@") > 0) {
            accountInfo.email = this.usernameOrEmail;
        } else {
            accountInfo.nickname = this.usernameOrEmail;
        }
        accountInfo.password = this.userPassword;
        this.permissionService.signin(accountInfo).then( (userInfo: UserInfo) => {
            console.log("LoginComponent.onSubmit() - User logged: " + JSON.stringify(userInfo));
            if( SharedUtils.inputValueIsPresent(userInfo.citizenInfo?.id) && SharedUtils.inputValueIsPresent(userInfo.activeLegalEntityInfo?.id) && userInfo.activeUserLegalEntityInfo?.statusId === EnumUserLegalEntityStatus.active ) {
                this.router.navigateByUrl("dossier/main");
            } else {
                this.router.navigateByUrl("membership/profileAccount");
            }
            this.permissionService.setWaitingSpinner(false);
        }).catch( (error: any) => {
            console.log("LoginComponent.onSubmit() - Login error: " + (JSON.stringify(error)) );
            const returnedError: EncodeErrorInfo = error.error;
            // console.error("LoginComponent.onSubmit() - An error occurred: " + JSON.stringify(error));
            // console.error("LoginComponent.onSubmit() - An error occurred: " + (returnedError.code ?? (returnedError.message ?? (error.code ?? error.message) ) ) );
            if (
                SharedUtils.inputValueIsPresent(returnedError?.code) &&
                (
                    returnedError?.code === EnumEncodeError.NICKNAME_NOT_FOUND ||
                    returnedError?.code === EnumEncodeError.EMAIL_NOT_FOUND ||
                    returnedError?.code === EnumEncodeError.WRONG_PASSWORD
                )
            ) {
                console.log("LoginComponent.onSubmit() - Login error: " + returnedError?.code);
                form.controls['email'].updateValueAndValidity();
                form.controls['password'].reset();
                this.error = true;
                this.permissionService.setWaitingSpinner(false);
            } else {
                this.permissionService.setWaitingSpinner(false);
                const message: string = ( SharedUtils.inputValueIsPresent(returnedError?.code) && returnedError.code === EnumEncodeError.USER_NOT_FOUND) ? "Utente non ancora verificato: controlla la tua casella di posta e segui le istruzioni che hai ricevuto." : "Si è verificato un errore imprevisto: riprovare più tardi.";
                this.permissionService.alert(message);
                form.controls['email'].updateValueAndValidity();
                form.controls['password'].reset();
                console.log("LoginComponent.onSubmit() - Login error: " + returnedError?.code);
            }
        });
    }
    
    // logCurrentPosition() {
        // navigator.geolocation.getCurrentPosition(
        //     (position) => console.log("navigator.geolocation.getCurrentPosition(success): ", position),
        //     (error) => console.log("navigator.geolocation.getCurrentPosition(error): ", error)
        // );
        // navigator.geolocation.watchPosition(
        //     (position) => console.log("navigator.geolocation.watchPosition(success): ", position),
        //     (error) => console.log("navigator.geolocation.watchPosition(error): ", error)
        // ); 
    // }
}
